import { TeliaCol, TeliaRow } from '@teliads/components/react';

import BusinessContentCard from '../business-content-card/BusinessContentCard';
import CardContentWrapper from '../card-content-wrapper/CardContentWrapper';

import Carousel from 'components/custom/carousel/Carousel';
import { CarouselVariant } from 'components/custom/carousel/types';
import { BaseCardContent, CtaContent } from 'utils/models';
import { renderRichText } from 'utils/rich-text-render';

import './UspCardsCardDisplay.scss';

type UspCardsCardDisplayProps = {
  items: BaseCardContent[];
  title?: string;
  preamble?: any;
  cta?: CtaContent;
  backgroundColor?: string;
  titleCentered?: boolean;
  isCarousel?: boolean;
};

const UspCardsCardDisplay = ({
  items,
  title,
  preamble,
  cta,
  backgroundColor,
  titleCentered,
  isCarousel,
}: UspCardsCardDisplayProps) => {
  return (
    <section className="usp-cards" style={{ backgroundColor: backgroundColor }}>
      <CardContentWrapper
        title={title}
        preamble={preamble ? renderRichText(preamble.json) : undefined}
        cta={cta}
        isTitleCentered={titleCentered}
        titleVariant={titleCentered ? 'display-25' : 'title-300'}
      >
        {isCarousel && (
          <Carousel variant={CarouselVariant.EXTRA_SMALL}>
            {items.map((item, id: number) => (
              <BusinessContentCard
                key={item.title + id}
                title={item.title}
                preamble={item.body}
                cta={{
                  url: item.url,
                  text: item.tagline,
                }}
                image={item.image}
              />
            ))}
          </Carousel>
        )}
        {!isCarousel && (
          <TeliaRow style={{ display: 'flex', flexWrap: 'wrap' }}>
            {items.map((item, id: number) => (
              <TeliaCol
                width={12}
                widthMd={6}
                widthLg={3}
                key={item.title + id}
                style={{ marginBottom: '12px' }}
              >
                <BusinessContentCard
                  title={item.title}
                  preamble={item.body}
                  cta={{
                    url: item.url,
                    text: item.tagline,
                  }}
                  image={item.image}
                />
              </TeliaCol>
            ))}
          </TeliaRow>
        )}
      </CardContentWrapper>
    </section>
  );
};

export default UspCardsCardDisplay;
